module.exports = __webpack_public_path__ + "585e6e287d7703f13f3ad00674f405c6.pdf";